// extracted by mini-css-extract-plugin
module.exports = {"svgLinkIcon":"LinkIcon_svgLinkIcon__25EgY"};